import { BelegungsIntervall } from '@/domain/dienstplan/shared/types/Belegung';

export function isMouseInInterval(
  intervall: BelegungsIntervall[],
  position: { x: number; y: number },
): boolean {
  for (let index = 0; index < intervall.length; index++) {
    const element = intervall[index];
    if (
      element.startX < position.x &&
      position.x < element.startX + element.width
    ) {
      return true;
    }
  }
  return false;
}
